export default {
    dashboard: "Dashboard",
    calendar: "Calendar",
    containers: "Container",
    activity: "Activity",
    quotes: "Quotes",
    orders: "Orders",
    receivers: "Receivers",
    shippers: "Shippers",
    team: "Team",
    addressBook: "Address Book",
    settings: "Settings",
    accounts: "Accounts",
    support: "Support",
    logout: "Logout",
    documents: "Documents",
    workflows: "Workflows",
    knowledgeBase: "Knowledge Base",
};
